
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.672 14.366c.149-.291.251-.608.298-.942a2.985 2.985 0 00-.57-2.226 3.006 3.006 0 00-4.2-.599c-.507.38-.898.848-1.2 1.336a4.838 4.838 0 00-1.2-1.336 2.985 2.985 0 00-2.224-.57 2.982 2.982 0 00-1.977 1.17 2.981 2.981 0 00-.569 2.225c.048.333.149.65.298.942A4.005 4.005 0 008 18v2c0 .728.196 1.411.537 2H5c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h6a3 3 0 012.906 2.249 1.001 1.001 0 001.937-.498A4.997 4.997 0 0011.001 4h-.586l1.293-1.293a.999.999 0 10-1.414-1.414L9.001 2.586V1a1 1 0 10-2 0v1.586L5.708 1.293a.999.999 0 10-1.414 1.414L5.587 4h-.586A5.006 5.006 0 000 9v10c0 2.757 2.243 5 5 5h15c2.206 0 4-1.794 4-4v-2a4.007 4.007 0 00-2.328-3.634zM18.4 12.2a.996.996 0 011.4.2.992.992 0 01.19.742.994.994 0 01-.391.659 1.945 1.945 0 01-.336.199h-2.026c.198-.61.549-1.34 1.163-1.8zm-6.2.2a.998.998 0 011.401-.201c.614.46.965 1.19 1.163 1.8h-2.025a1.86 1.86 0 01-.339-.201.994.994 0 01-.39-.657.99.99 0 01.189-.741zM10 20v-2c0-1.103.897-2 2-2h3v6h-3c-1.103 0-2-.897-2-2zm12 0c0 1.103-.897 2-2 2h-3l-.003-6H20c1.103 0 2 .897 2 2v2z"}})])
          )
        }
      }
    